import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=4ec0e3f9&scoped=true"
import script from "./Divider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Divider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0e3f9",
  null
  
)

export default component.exports